<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar class="mb-4">
            <v-toolbar-title>
                <span>{{ $t('contacts.confirmBulkDelete.title') }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <span>{{ $tc('contacts.confirmBulkDelete.message', contacts.length, { count: contacts.length }) }}</span><br/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            :loading="loading"
            color="red"
            :disabled="contacts.length === 0"
            @click="confirmAction()"
          >
            {{ $t('contacts.btn.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'contacts-confirmBulkDelete',
  data () {
    return {
      loading: false
    }
  },
  props: {
    dialog: { type: Boolean, default: false },
    contacts: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions({
      bulkDelete: 'contacts/bulkDelete'
    }),
    async confirmAction () {
      this.loading = true
      await this.bulkDelete(this.contacts)
      this.loading = false
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>
